var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "52px",
    viewBox: "0 0 64 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1007.000000, -550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1009.000000, 551.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.54747351e-13,21.3075479 L-4.54747351e-13,10.5154039 C-4.54814986e-13,9.96311917 0.44771525,9.51540392 1,9.51540392 L58.8916817,9.51540392 C59.4439665,9.51540392 59.8916817,9.96311917 59.8916817,10.5154039 L59.8916817,21.3081368 C59.8916817,21.7661866 59.5804741,22.1656767 59.1363454,22.2777448 L30.2364394,29.5701319 C30.0760877,29.6105939 29.908204,29.6106554 29.7478227,29.5703109 L0.756046901,22.2773349 C0.311571303,22.1655257 -4.52766854e-13,21.7658708 -4.54747351e-13,21.3075479 Z",
    id: "Path-26",
    stroke: "#000000",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 23.4921536,
    y: 23.6798745,
    width: 13,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.54747351e-13,26.9741868 L-4.54747351e-13,45.779961 C-4.52781161e-13,47.4368152 1.34314575,48.779961 3,48.779961 L56.8916817,48.779961 C58.548536,48.779961 59.8916817,47.4368152 59.8916817,45.779961 L59.8916817,26.9741868 L59.8916817,26.9741868",
    id: "Path-27",
    stroke: "#000000",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9502717,5.24878246 L19.9502717,2 C19.9502717,0.8954305 20.8457022,2.02906125e-16 21.9502717,0 L38.4292612,0 C39.5338307,-2.02906125e-16 40.4292612,0.8954305 40.4292612,2 L40.4292612,5.24878246 L40.4292612,5.24878246",
    id: "Path-28",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressOffice);
export default __webpack_public_path__ + "static/media/address-office.55bf1b7c.svg";
export { ForwardRef as ReactComponent };